var m = require('mithril');
var prop = require('mithril/stream');
var loaders = require('../layout/components/loaders');
var modal = require('../layout/components/modal');
var modalForm = require('../layout/components/modalForm');
var header = require('../layout/components/header');
var buttonElement = require('../components/button');
var permissionModal = modalForm(require('./models/permission'));
var rowActionDropdown = require('../components/rowActionDropdown');
var permissionGroupFilter = require('../libs/permissionGroupFilter');

var page = {};

page.oninit = function () {
  var ctrl = this;
  header.vm.activeTab('Reports');

  ctrl.reportFolder = prop(null);
  ctrl.permissions = prop([]);
  ctrl.groups = prop();

  ctrl.init = function () {
    Promise.all([
      loaders.requestWithLoader({
        url: '/api/v1/reportfolder/' + m.route.param('id'),
        method: 'GET',
        background: true
      })
      .then(function (reportFolder) {
        ctrl.reportFolder(reportFolder);
      }),
      loaders.requestWithLoader({
        url: '/api/v1/reportfolder/' + m.route.param('id') + '/permissions',
        method: 'GET',
        background: true,
      })
      .then(function (records) {
        ctrl.permissions(records.map(r => {
          r.dashboard = '#' + m.route.param('id');
          r.group = r.in;
          return r;
        }));
      }),
      loaders.requestWithLoader({
        url: '/api/v1/group/',
        method: 'GET',
        background: true
      })
      .then( groups => {
        ctrl.groups(groups)
      })
    ])
    .then(() => m.redraw());
  };

  modal.on('closed', ctrl.init);
  
  ctrl.init();
};

page.onremove = function () {
  modal.off('closed', this.init);
};

page.view = function (vnode) {
  var ctrl = this;
  if (!ctrl.groups() || !ctrl.reportFolder()) return

  function heading () {
    return m('div.mb3.bb.bw1.b--mid-gray.near-white.f-subheadline.fw1.pb2', [
      m('div.mr2.dib-ns', [
        m(m.route.Link, {href:'/reports'}, 'Reports'),
        ' / '
      ]),
      m('div.mr2.dib-ns', [
        ctrl.reportFolder().name,
        ' - ',
        ' Permissions '
      ])
    ]);
  }

  function groupName(permission) {
    var permissionGroupRid = permission && permission.in && permission.in['@rid'];
    var group = ctrl.groups().find(function (record) {
      return record['@rid'] === permissionGroupRid;
    });
    return group && group.name ? group.name : 'Unknown Group';
  }

  return m('div', {class:'container'}, [
    heading(),
    m('table.w-100', [
      m('thead.f3', [
        m('tr', [ 
          m('th', ''),
          m('th', 'Group Name'),
          m('th', 'Read Permission'),
          m('th', 'Write Permission'),
          m('th', 'Actions')
        ])
      ]),
      m('tbody', [
        ctrl.permissions().map(function (permission) {
          return m('tr.tc', [
            m('td'),
            m('td', groupName(permission)),
            m('td', (permission.read == 1 || permission.write == 1 ? 'Yes' : 'No')),
            m('td', (permission.write  == 1 ? 'Yes' : 'No')),
            m('td', [
              m(rowActionDropdown, {
                items: [
                  {
                    label: 'Edit Permission',
                    icon: 'ion-ios-compose',
                    onclick: permissionModal.editDialogue.bind(permissionModal, permission)
                  },
                  {
                    label: 'Delete Permission',
                    icon: 'ion-ios-trash',
                    class: 'red',
                    onclick: permissionModal.deleteDialogue.bind(permissionModal, permission)
                  }
                ]
              })
            ])
          ])
        })
      ])
    ]),
    m(buttonElement, {
      label: 'Add Group',
      func: permissionModal.editDialogue.bind(permissionModal, {
        dashboard: ctrl.reportFolder()['@rid'],
        read: 0,
        write: 0,
        existingGroupRids: permissionGroupFilter.existingGroupRidsFromPermissions(ctrl.permissions())
      }),
      class: 'btn-default icon-right mt3'
    }),
  ])
}

module.exports = page;
